<script setup lang="ts">
const { status } = useAuth();
const isLoggedIn = computed(() => status.value === 'authenticated');
const config = useRuntimeConfig();
const cc = config.public.clientConfig as any;
const appName = cc?.appName ?? 'SpreadIt';
const contactEmail = cc?.landing?.contactEmail ?? '';
</script>

<template>
  <footer v-if="!isLoggedIn" class="border-t border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-950 text-sm text-gray-500 dark:text-gray-400">
    <div class="max-w-5xl mx-auto px-6 py-8 flex flex-col sm:flex-row items-center justify-between gap-4">
      <Brand />
      <div class="flex gap-6">
        <a v-if="contactEmail" :href="`mailto:${contactEmail}`" class="hover:text-gray-700 dark:hover:text-gray-200 transition-colors">{{ contactEmail }}</a>
      </div>
      <p>© {{ new Date().getFullYear() }} {{ appName }}</p>
    </div>
  </footer>
</template>
